export var SubscriptionVerficationStatus;
(function (SubscriptionVerficationStatus) {
    SubscriptionVerficationStatus["VERIFIED"] = "verified";
    SubscriptionVerficationStatus["UNVERIFIED"] = "unverified";
    SubscriptionVerficationStatus["FAILED"] = "failed";
    SubscriptionVerficationStatus["AUTOFAILED"] = "autofailed";
})(SubscriptionVerficationStatus || (SubscriptionVerficationStatus = {}));
export function isFailedVerification(status) {
    return (status === SubscriptionVerficationStatus.FAILED ||
        status === SubscriptionVerficationStatus.AUTOFAILED);
}
//# sourceMappingURL=subscription.js.map